<div class="confirm-modal ig-modal edit-place-images-modal text-gray-600">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <h3 theme border-b class="title">EDIT PLACE IMAGES</h3>

    <div class="edit-wrap">
        <div *ngIf="!isGoogleInfoLoaded" class="flex justify-center my-8">
            <div class="flex flex-col items-center gap-2">
                <ig-spinner></ig-spinner>
                Loading new images...
            </div>
        </div>

        <div *ngIf="isGoogleInfoLoaded" class="relative">
            <h4 class="block !my-4">
                Each place listing can display up to {{ totalImageCountThatSysAdminSet }} images, in a slideshow, with
                the
                first picture acting as the cover photo. The cover may be the first Google image available or a manual
                upload
                of your choice. Drag-and-drop images in place to re-order how they appear.
            </h4>

            <h3 class="image-title">Images Displayed on Website Listing</h3>

            <div class="image-gallery">
                <!-- Regular published images -->
                <div 
                    *ngFor="let img of publishedImages; let i = index" 
                    class="gallery-item" 
                    draggable="true"
                    (dragstart)="onDragStart($event, i, 'published')"
                    (dragover)="onDragOver($event, i, 'published')"
                    (dragenter)="onDragEnter($event, i, 'published')"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop1($event, i, 'published')"
                    (dragend)="onDragEnd($event)"
                    [class.drag-over]="i === dragOverIndex && dragOverList === 'published'">
                    <img [src]="getImage(img)" [alt]="'Image ' + (i + 1)" class="gallery-image">

                    <div *ngIf="isClientUploaded(img)||isWaitingForUpload(img)"
                        class="absolute flex justify-center items-center gap-4 cursor-pointer rounded-full bg-red-400 text-white top-0 right-0"
                        (click)="removeOwnedImageFromAllowed(img, 'published')"
                        matTooltip="Remove from allowed list. Only manually uploaded images can be removed">
                        <mat-icon>clear</mat-icon>
                    </div>
                </div>
                
                <!-- Compensate elements (not draggable) -->
                <div 
                    *ngFor="let item of compensateForPublished; let i = index" 
                    class="gallery-item compensate-item"
                    [class.no-drop]="currentDragList === 'published' && draggedItemIndex === publishedImages.length - 1"
                    (dragover)="onCompensateDragOver($event, i, 'published')"
                    (dragenter)="onCompensateDragEnter($event, i, 'published')"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop1($event, publishedImages.length + i, 'published')"
                    [class.drag-over]="dragOverCompensateIndex === i && dragOverList === 'published'">
                    <div class="compensate-placeholder"></div>
                    </div>
              </div>     
              
              <!-- Available Images Section -->
              <h3 class="available-title">{{place.socialName === 'google' ? 'Available Images from Google' : 'Backup Images'}}</h3>
              <div class="image-gallery available-gallery">
                <div 
                    *ngFor="let img of availableImages; let i = index" 
                    class="gallery-item" 
                    draggable="true"
                    (dragstart)="onDragStart($event, i, 'available')"
                    (dragover)="onDragOver($event, i, 'available')"
                    (dragenter)="onDragEnter($event, i, 'available')"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop1($event, i, 'available')"
                    (dragend)="onDragEnd($event)"
                    [class.drag-over]="i === dragOverIndex && dragOverList === 'available'">
                    <img [src]="getImage(img)" [alt]="'Available Image ' + (i + 1)" class="gallery-image">
                    <div *ngIf="isClientUploaded(img)||isWaitingForUpload(img)"
                        class="absolute flex justify-center items-center gap-4 cursor-pointer rounded-full bg-red-400 text-white top-0 right-0"
                        (click)="removeOwnedImageFromAllowed(img, 'available')"
                        matTooltip="Remove from allowed list. Only manually uploaded images can be removed">
                        <mat-icon>clear</mat-icon>
                    </div>
                </div>
                                    
                                    <!-- Compensate elements for available images (not draggable) -->
                                    <div 
                    *ngFor="let item of compensateForAvailable; let i = index" 
                    class="gallery-item compensate-item"
                    (dragover)="onCompensateDragOver($event, i, 'available')"
                    (dragenter)="onCompensateDragEnter($event, i, 'available')"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop1($event, availableImages.length + i, 'available')"
                    [class.drag-over]="dragOverCompensateIndex === i && dragOverList === 'available'">
                    <div class="compensate-placeholder"></div>
                </div>
              </div>

            <h3 >Upload Your Owned Images</h3>
            <h4 class="!my-4 block">
                Include your photography to replace or complement the {{place.socialName === 'google' ? 'Google' : ''}} Images. By uploading you confirm that your
                organization has the right to use and share these images.
            </h4>
            <div class="flex items-center gap-3">
                <button theme class="w-[180px] py-2 text-white rounded-[2px] hover:shadow-md transition-all" (click)="imageSelector.click()">
                    Upload New Image
                </button>
                <button theme class="w-[180px] py-2 text-white rounded-[2px] hover:shadow-md transition-all"
                     #inputLinkMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="inputLinkMenu">
                    Enter Image Link
                </button>
                <input type="file" class="invisible" multiple="multiple" accept="image/png,image/gif,image/jpeg"
                    #imageSelector (change)="onImageChange($event)" />

                    <mat-menu #inputLinkMenu="matMenu" class="!w-[700px] !max-w-[700px] overflow-hidden" igClickStopPropagation>
                        <div class="p-4" igClickStopPropagation>
                            <input type="text" placeholder="Enter image link" [(ngModel)]="imageLink"
                            class="flex-1 px-3 py-2 w-full border rounded bg-white border-gray-300 focus:border-blue-400 focus:outline-blue-400"/>
                            <ig-button theme class="w-[100px] block mt-3" cls="w-[100px]" (trigger)="enterImageLink($event, inputLinkMenuTrigger)">OK</ig-button>
                        </div>
                    </mat-menu>
            </div>

            <div class="image-gallery owned-gallery m-t-3">
                <!-- Draggable owned images -->
                <div 
                    *ngFor="let image of ownedImages; let i = index"
                    class="gallery-item max-w-[30%] !h-[120px] relative flex justify-center items-center pr-3 pt-3"
                    draggable="true"
                    (dragstart)="onDragStart($event, i, 'owned')"
                    (dragover)="onDragOver($event, i, 'owned')"
                    (dragenter)="onDragEnter($event, i, 'owned')"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop1($event, i, 'owned')"
                    (dragend)="onDragEnd($event)"
                    [class.drag-over]="i === dragOverIndex && dragOverList === 'owned'">
                    <img [src]="getImage(image.url)" [alt]="'Owned Image ' + (i + 1)" class="gallery-image">
                    <div class="absolute flex justify-center items-center gap-4 bg-red-400 text-center rounded-full w-6 h-6 right-0 top-0 cursor-pointer" 
                        (click)="removeOwnImage(i)" igClickStopPropagation
                        [matTooltip]="isWaitingForUpload(image.url) ? 'Remove' : 'Delete permanently'">
                        <mat-icon class="text-white !leading-6 !text-[20px]">clear</mat-icon>
                    </div>
                    <div *ngIf="image.status !== 'done' && image.status !== 'initial'"
                        class="absolute flex flex-col justify-center items-center gap-2"
                        style="width: 120px;height: 60px;color: white;background-color: #00000073;">
                        <mat-icon>
                            {{
                            image.status === 'uploading'
                            ? 'autorenew'
                            : image.status === 'uploaded'
                            ? 'check'
                            : 'clear'
                            }}
                        </mat-icon>
                        <div class="flex gap-2">
                            <span>{{ image.status }}</span>
                            <span *ngIf="image.status==='failed'" class="link"
                                (click)="uploadOwnedImagesToAWS()">Retry</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="action-btns">
        <ig-button theme #confirmButton [isAsync]="true"
            (trigger)="confirm($event)" [disabled]="!isGoogleInfoLoaded">
            Confirm
        </ig-button>
        <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
            Cancel
        </div>
    </div>
</div>